module.exports = __webpack_public_path__ + "static/media/expand-arrows-alt.4fe6cb72.svg";